// Module
var code = "<div tabindex=\"0\" class=\"rip-dialog-window {{windowStyleName}}\" rip-dialog-position rip-box-resizer> <div class=\"rip-dialog-header\"> <span class=\"rip-dialog-header-title\">{{windowTitle}}</span> </div> <div class=\"rip-dialog-body\" ng-transclude></div> </div> ";
// Exports
module.exports = code;